<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>FOR CHRIS—ACCOMPLICE LONG AFTER THE FACT</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9c1d1a98